import React, { useState, useCallback, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { log } from "../utils/logger";
import "./Navbar.css";

export const Navbar = () => {
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    useEffect(() => {
        fetch("/config.json")
            .then((res) => res.json())
            .then((config) => {
                log("Navbar", "Загружен config", { hasHelpsLink: !!config["helps-link"] });
            })
            .catch((err) => log("Navbar", "Ошибка загрузки config", err));
    }, []);

    const closeMenu = useCallback(() => setMenuOpen(false), []);

    const handleNavClick = (e: React.MouseEvent) => {
        closeMenu();
    };

    const handleLogout = () => {
        log("Navbar", "Выход из системы");
        logout();
        closeMenu();
    };

    const handleBrandClick = () => {
        closeMenu();
        navigate("/");
    };

    return (
        <header className={`navbar ${menuOpen ? "navbar-menu-open" : ""}`}>
            <button
                type="button"
                className="navbar-brand navbar-brand-button"
                onClick={handleBrandClick}
                aria-label="УСН Профи — на главную"
            >
                <span className="navbar-brand-lockup">
                    <span className="navbar-brand-usn">УСН</span>
                    <span className="navbar-brand-dot" aria-hidden="true" />
                    <span className="navbar-brand-profi">Профи</span>
                </span>
            </button>

            <button
                type="button"
                className="navbar-burger"
                onClick={() => setMenuOpen((o) => !o)}
                aria-label={menuOpen ? "Закрыть меню" : "Открыть меню"}
                aria-expanded={menuOpen}
            >
                <span className="navbar-burger-line" />
                <span className="navbar-burger-line" />
                <span className="navbar-burger-line" />
            </button>

            <nav className={`navbar-nav ${menuOpen ? "navbar-nav-open" : ""}`}>
                <ul className="navbar-nav-list">
                    <li className="navbar-nav-center">
                        <ul className="navbar-nav-inner">
                            <li>
                                <NavLink to="/about" className="navbar-link" onClick={handleNavClick}>
                                    О нас
                                </NavLink>
                            </li>
                            {isAuthenticated && (
                                <>
                                    <li>
                                        <NavLink to="/" className="navbar-link" onClick={handleNavClick}>
                                            Главное меню
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/senddata" className="navbar-link" onClick={handleNavClick}>
                                            Отправить данные
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            to="/feedback"
                                            className="navbar-link"
                                            onClick={handleNavClick}
                                        >
                                            Обратная связь
                                        </NavLink>
                                    </li>
                                </>
                            )}
                        </ul>
                    </li>
                    <li className="navbar-nav-right">
                        {isAuthenticated ? (
                            <button
                                type="button"
                                className="navbar-link navbar-link-logout"
                                onClick={handleLogout}
                            >
                                Выйти из системы
                            </button>
                        ) : (
                            <NavLink to="/login" className="navbar-link navbar-link-login" onClick={handleNavClick}>
                                Войти
                            </NavLink>
                        )}
                    </li>
                </ul>
            </nav>
            {menuOpen && (
                <div className="navbar-backdrop" onClick={closeMenu} aria-hidden="true" />
            )}
        </header>
    );
};